import { changeDpiBlob } from "changedpi";
import JsZip from "jszip";
import FileSaver from "file-saver";

function checkCanvas(canvas) {
  if (canvas === null) {
    throw new Error(
      "No canvas supplied, please call CanvasCapture.init() and pass in canvas element."
    );
  }
}

async function canvasToBlobAsync(canvas: HTMLCanvasElement, quality?: number) {
  return new Promise((resolve: (blob: Blob | null) => void) => {
    canvas.toBlob(
      (blob: Blob | null) => {
        resolve(blob);
      },
      `image/jpeg`,
      quality
    );
  });
}
export async function takeImageSnapshot(
  canvas: HTMLCanvasElement,
  filename: string,
  quality?: number,
  options?: {
    dpi?: number;
    onExportFinish?: () => void;
    onExport: (blob: Blob, filename: string) => void;
  }
) {
  checkCanvas(canvas);
  const onExportFinish = options?.onExportFinish;
  const blob = await canvasToBlobAsync(canvas!, quality);
  if (!blob) {
    const errorMsg = `Problem saving image, please try again!`;
    throw new Error(errorMsg);
  }
  const onExport = options?.onExport;
  if (options?.dpi) {
    await changeDpiBlob(blob, options?.dpi).then((blob: Blob) => {
      onExport(blob, filename);
      if (onExportFinish) onExportFinish();
    });
  } else {
    onExport(blob, filename);
    if (onExportFinish) onExportFinish();
  }
}

export const exportZip = async (zipName, filename, blobs) => {
  const zip = JsZip();
  blobs.forEach((blob, i) => {
    zip.file(`${filename}-${i}.jpg`, blob);
  });
  await zip.generateAsync({ type: "blob" }).then((zipFile) => {
    const currentDate = new Date().getTime();
    const fileName = `${zipName}-${currentDate}.zip`;
    return FileSaver.saveAs(zipFile, fileName);
  });
};
